<template>
  <v-container class="request-container">
    <div class="form-container duallo-card">
      <header class="request-head">
        <div class="duallo-eyebrow">Model generation</div>
        <h2 class="request-title">New Generation Request</h2>
      </header>

      <v-row>
        <!-- Details column -->
        <v-col cols="12" sm="6" class="request-col">
          <v-text-field
            label="Name"
            v-model="name"
            variant="outlined"
            density="comfortable"
            hide-details="auto"
            class="duallo-field mb-4"
          ></v-text-field>

          <div class="request-actions">
            <v-btn
              color="secondary"
              variant="outlined"
              block
              @click="handleCancel"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              block
              @click="handleGenerate"
            >
              Generate
            </v-btn>
          </div>
        </v-col>

        <!-- Upload column -->
        <v-col cols="12" sm="6" class="request-col">
          <div
            class="upload-area"
            @dragover.prevent
            @drop.prevent="handleFileDrop"
          >
            <v-icon size="32" color="#8aa0aa">mdi-cloud-upload-outline</v-icon>
            <p class="upload-hint">Drag and drop files here to upload</p>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { useConfirm } from '@/composable/useConfirm';

export default {
  name: 'NewRequest',
  setup() {
    const { confirm } = useConfirm();
    return { confirm };
  },
  data() {
    return {
      name: '', // Holds the value of the text input
    };
  },
  methods: {
    async handleCancel() {
      // Confirm before discarding the in-progress request.
      const ok = await this.confirm({
        title: 'Discard this request?',
        message: 'Your entered details will not be saved.',
        confirmText: 'Discard',
        cancelText: 'Keep editing',
        danger: true,
        icon: 'mdi-close-circle-outline',
      });
      if (!ok) return;
      this.$router.push({ name: 'Assets' });
    },
    async handleGenerate() {
      // Confirm before kicking off generation, then run the (stub) submission.
      const ok = await this.confirm({
        title: 'Generate model?',
        message: 'This will queue a new generation request.',
        confirmText: 'Generate',
        cancelText: 'Cancel',
        icon: 'mdi-cog-play-outline',
      });
      if (!ok) return;
      // Stub: actual submission logic to be implemented.
      this.$router.push({ name: 'Assets' });
    },
    handleFileDrop(event) {
      const files = event.dataTransfer.files;
      // Handle the files as needed (e.g., upload or preview)
      console.log('Files uploaded:', files);
    },
  },
};
</script>

<style scoped>
.request-container {
  max-width: 960px;
}

.form-container {
  padding: clamp(16px, calc(12px + 1vw), 28px);
}

.request-head {
  margin-bottom: 20px;
}
.request-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 2px 0 0;
  color: var(--duallo-text-primary);
}

.request-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.request-actions > * {
  flex: 1 1 140px;
}

.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 2px dashed var(--duallo-border-strong);
  border-radius: var(--duallo-radius-md);
  padding: 20px;
  min-height: 150px;
  text-align: center;
  background: rgba(255, 255, 255, 0.02);
  transition: border-color 0.15s ease, background 0.15s ease;
}
.upload-area:hover {
  border-color: var(--duallo-border-accent);
  background: rgba(100, 255, 218, 0.04);
}
.upload-hint {
  margin: 0;
  color: var(--duallo-text-tertiary);
  font-size: 0.9rem;
}
</style>
